import { Field, ThemeProps } from 'react-jsonschema-form'
import { getDefaultRegistry } from 'react-jsonschema-form/lib/utils'

import ErrorList from './ErrorList'
import { DescriptionField, LayoutField, TitleField } from './Fields'
import FieldTemplate from './FieldTemplate'
import ObjectFieldTemplate from './ObjectFieldTemplate'
import Widgets from './Widgets'

const { fields, widgets } = getDefaultRegistry()

const Theme: ThemeProps = {
  ErrorList,
  FieldTemplate,
  ObjectFieldTemplate,
  fields: {
    ...fields,
    DescriptionField,
    LayoutField: LayoutField as Field,
    TitleField,
  },
  widgets: { ...widgets, ...Widgets },
}

export default Theme
